import useSWR from "swr";

import { useCurrentLocale } from "@/context/LanguageContext";

import { SuggestionProps } from "@/interfaces/stores-interface";

import { fetcher } from "./useSearch";

export const useSearchAutocomplete = (searchTerm: string, httpCorrelationId: string) => {
    const locale = useCurrentLocale();

    const params = new URLSearchParams({
        query: searchTerm,
        locale: locale,
        cor_id: httpCorrelationId,
    });

    const url = searchTerm ? `/api/store-directory/suggestions?${params.toString()}` : null;
    const { data } = useSWR<SuggestionProps[]>(url, fetcher, {
        shouldRetryOnError: false,
    });
    return data ?? [];
};
